// extracted by mini-css-extract-plugin
module.exports = {"tablet-side-menu":"TabletSideMenu_tablet-side-menu__aeCra","links":"TabletSideMenu_links__M3W1N","link":"TabletSideMenu_link__FXQJv"};